import React from "react";

function PricingPage() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Pricing</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Pricing</li>
            </ul>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="pricing_section pt_150 pb-100">
        <div className="shape_bg"></div>
        <div className="shape_six float-bob-y">
          <img src="/images/icons/shape_icon_6.png" alt="Shape Icon" />
        </div>
        <div className="container">
          <div className="section_title centred">
            <div className="tag_text">
              <h6>SEBI Registered • Trusted by 10,000+ Investors</h6>
            </div>
            <h2>PMS Investment Tiers</h2>
            <p>
              Portfolio Management Services available across multiple investment
              levels
            </p>
          </div>

          <div className="row">
            {/* Account Handling Services */}
            <div className="col-lg-4 col-md-6 col-sm-12 pricing_block">
              <div
                className="pricing_block_one"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="100"
              >
                <div className="pricing_table">
                  <div className="table_header">
                    <h5>Account Handling Services</h5>
                    <p>
                      Expert algorithmic trading management with MT4 & MT5
                      platforms across global markets.
                    </p>
                    <div className="rate">
                      ₹1–50L<span>minimum $1K–60K USD</span>
                    </div>
                  </div>
                  <div className="table_content">
                    <ul className="feature_list">
                      <li>
                        Access to Indian equity markets (NSE, BSE, MCX, NCDEX)
                      </li>
                      <li>Basic portfolio tracking</li>
                      <li>Quarterly reporting</li>
                    </ul>
                    <div className="link_btn">
                      <a href="#" className="btn_style_two">
                        <span>Get Started</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Portfolio Management Service */}
            <div className="col-lg-4 col-md-6 col-sm-12 pricing_block">
              <div
                className="pricing_block_one"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="200"
              >
                <div className="pricing_table">
                  <div className="table_header">
                    <h5>Portfolio Management Service</h5>
                    <p>
                      Mid-tier portfolio management with MT4 platform access
                    </p>
                    <div className="rate">
                      ₹50L+<span>minimum $100K+ USD</span>
                    </div>
                  </div>
                  <div className="table_content">
                    <ul className="feature_list">
                      <li>Everything in Account Handling</li>
                      <li>MT4 platform integration</li>
                      <li>Advanced analytics</li>
                      <li>Dedicated support</li>
                    </ul>
                    <div className="link_btn">
                      <a href="#" className="btn_style_two">
                        <span>Get PMS Plan</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Private Placement Program */}
            <div className="col-lg-4 col-md-6 col-sm-12 pricing_block">
              <div
                className="pricing_block_one"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="300"
              >
                <div className="pricing_table">
                  <div className="table_header">
                    <h5>Private Placement Program</h5>
                    <p>
                      Advanced portfolio management with MT5 platform access
                    </p>
                    <div className="rate">
                      ₹10cr+<span>minimum and above</span>
                    </div>
                  </div>
                  <div className="table_content">
                    <ul className="feature_list">
                      <li>Everything in PMS</li>
                      <li>MT5 platform integration</li>
                      <li>Custom strategies</li>
                      <li>Priority support</li>
                    </ul>
                    <div className="link_btn">
                      <a href="#" className="btn_style_two">
                        <span>Get PPP Plan</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p>
            *All plans include comprehensive risk management and regulatory
            compliance.
          </p>
        </div>
      </section>
    </main>
  );
}

export default PricingPage;
